import { type CollectionType, type QueryItem } from '@directus/sdk';
import { type CustomDirectusTypes } from '@funnellab/shared/src/types/directus.ts';

export const organizationJobsQuery = {
  fields: ['id', 'idExternal', 'title', 'status', 'nextRenewal'],
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'job'>
>;
